module.exports = __webpack_public_path__ + "src/img/trackList.8e7dddff.png";